import { Scope } from '@pubstack/common/src/scope'
import { FunctionComponent, useEffect } from 'react'
import User from '~/auth/User'
import { useAuthenticatedUser } from '~/auth/user.hooks'

const getFilter = (scopes: Scope[], user: User) => {
  if (user.isAdmin) {
    const currentScope = scopes.find((s) => s.id === user.currentScopeId)
    scopes = currentScope ? [currentScope] : scopes
  }
  const scopeIdFilter = scopes.map((s) => `scopeId:${s.id}`)
  const scopeFilter = scopes.map((s) => `scope:${s.name}`)
  const featureFilter = user.features.map((f) => `feature:${f.split(':')[2]}`)
  return [...scopeIdFilter, ...scopeFilter, ...featureFilter].join(';')
}

export const BeamerIntegration: FunctionComponent<{ scopes: Scope[] }> = ({ scopes }) => {
  const user = useAuthenticatedUser()

  useEffect(() => {
    const userData = {
      user_id: user.currentScopeId + ':' + user.profile.email,
      user_lastname: user.profile.email?.split('@')?.[0],
      user_firstname: ' ',
      user_email: user.profile.email,
      filter: getFilter(scopes, user),
    }
    if (window.Beamer) {
      window.Beamer.init()
      window.Beamer.update(userData)
    }
  }, [])

  return null
}
